document.addEventListener('DOMContentLoaded', () => {
  // Promoção: 5 peças ou mais = 50% de desconto em toda a encomenda.
  const BUNDLE_TARGET = 5;
  document.querySelectorAll('[data-bundle-builder]').forEach((builder) => {
    const cards = [...builder.querySelectorAll('[data-bundle-card]')];
    const count = builder.querySelector('[data-bundle-count]');
    const copy = builder.querySelector('[data-bundle-copy]');
    const progress = builder.querySelector('[data-bundle-progress]');
    const submit = builder.querySelector('[data-bundle-submit]');
    const error = builder.querySelector('[data-bundle-error]');
    let bundleLines = [];
    let bundleTotal = 0;
    let busy = false;

    const setError = (message = '') => {
      if (error) error.textContent = message;
    };

    const getBundleLines = (cart) => cart.items;

    const loadCart = async () => {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error('Não foi possível ler o carrinho.');
      const cart = await response.json();
      bundleLines = getBundleLines(cart);
      bundleTotal = cart.item_count || bundleLines.reduce((total, line) => total + line.quantity, 0);
    };

    const sync = () => {
      const selectedIds = bundleLines.map((line) => String(line.variant_id));
      const total = bundleTotal;
      const missing = Math.max(0, BUNDLE_TARGET - total);
      cards.forEach((card) => {
        const id = String(card.dataset.variantId);
        const isSelected = selectedIds.includes(id);
        const button = card.querySelector('[data-bundle-add]');
        card.classList.toggle('is-selected', isSelected);
        card.classList.remove('is-locked');
        button?.setAttribute('aria-pressed', String(isSelected));
        if (button && !button.disabled && button.dataset.pending !== 'true') {
          button.textContent = isSelected ? 'Adicionado' : 'Adicionar';
        }
      });
      if (count) count.textContent = total >= BUNDLE_TARGET ? `${total} peças` : `${total}/${BUNDLE_TARGET}`;
      if (copy) copy.textContent = missing ? `Escolhe mais ${missing} ${missing === 1 ? 'peça' : 'peças'}` : '50% de desconto ativo';
      if (progress) progress.style.width = `${Math.min(100, Math.round((total / BUNDLE_TARGET) * 100))}%`;
      submit?.classList.toggle('is-incomplete', total < BUNDLE_TARGET);
      if (submit) submit.textContent = total < BUNDLE_TARGET ? 'Ver o carrinho' : 'Finalizar encomenda';
    };

    const refreshState = async () => {
      await loadCart();
      sync();
      document.dispatchEvent(new CustomEvent('mimo:cart:refresh'));
    };

    cards.forEach((card) => {
      const button = card.querySelector('[data-bundle-add]');
      button?.addEventListener('click', async () => {
        if (busy || button.disabled) return;
        const id = String(card.dataset.variantId);
        const existingLine = bundleLines.find((line) => String(line.variant_id) === id);
        busy = true;
        button.dataset.pending = 'true';
        button.textContent = existingLine ? 'A remover…' : 'A adicionar…';
        setError();
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = existingLine
            ? await fetch(`${root}cart/change.js`, {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ id: existingLine.key, quantity: Math.max(0, existingLine.quantity - 1) })
              })
            : await fetch(`${root}cart/add.js`, {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
              });
          if (!response.ok) throw new Error('Não foi possível atualizar o bundle.');
          await refreshState();
        } catch (requestError) {
          setError('Não foi possível atualizar o bundle. Tenta novamente.');
        } finally {
          busy = false;
          delete button.dataset.pending;
          sync();
        }
      });
    });

    submit?.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('mimo:cart:refresh-open'));
    });

    loadCart().then(sync).catch(() => {
      setError('Não foi possível sincronizar o bundle com o carrinho. Atualiza a página e tenta novamente.');
    });
  });
});
